import R2Dom from "../helpers/R2Dom";

R2Dom.Methods.accordion = function (_this) {
    var accordion = _this.parentElement.parentElement;

    _this.addEventListener('click', function() {
        
        if(accordion.classList.contains('open')) {
            accordion.classList.remove('open');
        }else{
            if(document.querySelector('.accordion.open') && !document.querySelector('[data-allow-multiple]')) {
                document.querySelector('.accordion.open').classList.remove('open');
            }
            accordion.classList.add('open');
        }
    });
}
